export default "__VITE_ASSET__DIjpgbz3__"